import { ImportCustomWizard } from "import/containers";
import { Header, PageContent, PageHeader, Spacer } from "components";

export const ImportCustom = () => {
  return (
    <>
      <PageHeader>
        <Header title="Import livestock data" />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={3} />

        <ImportCustomWizard />
      </PageContent>
    </>
  );
};
